import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { id: "header1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cnt1 clearfix" }),
  /*#__PURE__*/_createElementVNode("div", { class: "cnt2 clearfix" })
], -1)
const _hoisted_2 = { class: "home_main_cnt1" }
const _hoisted_3 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_4 = { class: "errorform" }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = {
  class: "form-group",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconMenuKanriComponent = _resolveComponent("IconMenuKanriComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconMenuKanriComponent, { previewData: _ctx.iconMenuPreviewDataList }, null, 8, ["previewData"])
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        name: "btnBack",
        class: "btn btn-back btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
      }, " 戻る ")
    ])
  ], 64))
}